import { Box, Typography } from '@mui/material'
import React, { FC } from 'react'
import { useSelectedLanguage } from '../../../../../common/hooks/useSelectedLanguage'
import { useTranslation } from '../../../../../common/hooks/helper/useTranslation'
import { Appointment } from '../../types/treatments.types'
import { AppointmentActions } from './AppointmentActions'
import { AppointmentStatusComponent } from '../../../../../common/components/Dashboard/AppointmentStatus'

type Props = {
  appointment: Appointment
  isPast: boolean
  isOpen?: boolean
  editAppointment: (appointment: Appointment) => void
  cloneAppointment: (appointment: Appointment) => void
}

const AppointmentHeader: FC<React.PropsWithChildren<Props>> = (props) => {
  const { appointment, isPast, isOpen, editAppointment, cloneAppointment } =
    props

  const { t } = useTranslation()
  const date = appointment?.proposedDate
  const dateString = t('common:patientFormattedDate', { date })
  const timeString = t('common:patientFormattedTime', { date })
  const shouldDisplayTime =
    appointment?.isBetmenBooked || !!appointment?.eesztBookingId
  const dateTimeString = `${dateString}${
    shouldDisplayTime ? `, ${timeString}` : ''
  }`
  const selectedLanguage = useSelectedLanguage()

  return (
    <Box
      display="flex"
      flexDirection={{ xs: 'column', md: 'row' }}
      alignItems={{ xs: 'flex-start', md: 'center' }}
      minHeight={40}
      data-id={appointment?.id}
      data-cy={`AppointmentHeader-Box-${appointment?.id}`}
    >
      <Box width={280} flexShrink={0} mt={{ xs: 1, md: 0 }}>
        <Typography variant="body2" color="textSecondary">
          {dateTimeString}
        </Typography>
      </Box>

      <Box flex={1}>
        <Typography variant="body2">
          {appointment?.info?.doctorTitle[selectedLanguage]}
        </Typography>
      </Box>

      <Box
        display="flex"
        justifyContent={isOpen ? 'flex-start' : 'flex-end'}
        flexShrink={0}
        ml={{ md: 1 }}
      >
        {!isPast && <AppointmentStatusComponent status={appointment.status} />}
        <Box>
          <AppointmentActions
            appointment={appointment}
            isTreatmentItemPast={isPast}
            editAppointment={editAppointment}
            cloneAppointment={cloneAppointment}
          />
        </Box>
      </Box>
    </Box>
  )
}

export { AppointmentHeader }
